if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;

        this.variantData = this.getVariantData();

        this.init();
        this.updateDropdownSwatch();
        this.select.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();
          this.updateDropdownSwatch();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          document.body.classList.add('sticky-atc-bar-visible');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        // 2026-09-07: checkDevice()'s clientHeight read raced this bar's own
        // deferred stylesheet (media="print" ... onload="this.media='all'"
        // in sections/sticky-atc-bar.liquid, 2026-08-30 perf change) and the
        // >=768px product-image row (hidden/shown via the md:flex class at
        // sections/sticky-atc-bar.liquid), so --sticky-atc-bar-height could
        // get stuck under-reporting the real height with nothing to
        // re-measure it -- confirmed live (stuck 49px vs actual 96px at
        // >=768px), which let the bar's higher z-index paint over
        // back-to-top's button entirely. Re-measure on every real layout
        // change instead of relying on the one-shot snapshot.
        new ResizeObserver(() => this.checkDevice()).observe(this);

        // 2026-10-24: SHORT SCREENS ONLY. The rule below this comment assumes the
        // inline buy button starts ON screen, so the bar's job is to replace it
        // once you scroll past. On a short viewport that assumption fails: the
        // button sits below the fold at load, hasSeen never flips, and the page
        // offers no call to action at all until you scroll down past the button
        // and back. Confirmed on an iPhone at 14:24 on 2026-10-24 -- gallery,
        // title and price above the fold, Add To Cart below it, no sticky bar.
        //
        // Deliberately measured rather than a viewport-height breakpoint. A
        // pixel threshold needs a guessed number; mobile Safari changes the
        // viewport height as its chrome collapses on scroll, so a device can
        // cross that threshold mid-session; and it ignores how much sits above
        // the button, which varies per product (title length, badges, variant
        // picker, review stars). Measuring where the button actually lands is
        // exact and self-adjusting.
        //
        // Devices where the button already fits above the fold are UNCHANGED:
        // buttonStartsBelowFold is false for them and the original rule is the
        // only one that can fire.
        // Only show after the user has scrolled past the inline buy button.
        // threshold: [0, 1] fires at both enter and exit regardless of element height,
        // avoiding the issue where ratio===1 is never reached on tall elements.
        this.hasSeen = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Mark as seen the first time any part of the form enters the viewport.
              if (entry.isIntersecting) this.hasSeen = true;
              // Show only when the form has scrolled fully above the viewport.
              // Hide when visible or when the user has scrolled back above it.
              const aboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              let show = this.hasSeen && aboveViewport;
              // Short screens: the button does not fit above the fold at rest,
              // so show the bar whenever it is not FULLY in view -- including
              // half on, which the earlier !isIntersecting test treated as
              // visible and so left the page with no call to action.
              //
              // Measured per callback rather than once at init: at
              // connectedCallback the PDP gallery may not have loaded, so the
              // button can measure above the fold and then get pushed below it.
              // Document-relative (rect.bottom + scrollY) so the answer does
              // not depend on where the page happens to be scrolled to.
              if (this.startsBelowFold()) {
                const viewportHeight = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
                // A form taller than the viewport can never be "fully visible",
                // which would leave the bar permanently on. Fall back to the
                // original any-intersection test for that case. Same reasoning
                // as the threshold note above: ratio===1 is unreachable on
                // elements taller than the root.
                const fullyVisible =
                  entry.boundingClientRect.height > viewportHeight
                    ? entry.isIntersecting
                    : entry.boundingClientRect.top >= 0 && entry.boundingClientRect.bottom <= viewportHeight;
                if (!fullyVisible) show = true;
              }
              this.container.classList.toggle('sticky-atc-bar--show', show);
              // Mirrored onto body (rather than read back off .sticky-atc-bar--show
              // itself) so other fixed elements -- back-to-top.liquid -- can react
              // to real bar visibility via CSS without a DOM-adjacency assumption.
              document.body.classList.toggle('sticky-atc-bar-visible', show);
            });
          },
          { threshold: [0, 1] }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      // True when the inline buy button's bottom sits below the first
      // viewport-height of the document, i.e. it cannot be on screen at rest.
      startsBelowFold() {
        const rect = this.productFormActions.getBoundingClientRect();
        return rect.bottom + window.scrollY > window.innerHeight;
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        // 2026-10-22: the per-litre price shows on the main PDP only, not in the sticky bar.
        unitPriceWrapper.classList.add('hidden');

        this.updateVolume();
      }

      // 2026-08-30: keeps the hybrid select+swatch dot (see
      // sections/sticky-atc-bar.liquid's show_variant_swatch /
      // .sticky-atc-bar__variant-swatch) in sync with whichever <option>
      // is currently selected -- reads the same data-option-swatch-value
      // hex that liquid wrote onto each <option> from settings.swatch_list,
      // mirroring how variant-selects.js's updateSelectedSwatchValue does
      // the equivalent job for the main PDP picker's own swatch_dropdown
      // mode. No-op (both selectors just miss) on any product that didn't
      // opt into the swatch dot, so this is always safe to call.
      updateDropdownSwatch() {
        const swatchEl = this.querySelector('[data-sticky-variant-swatch]');
        if (!swatchEl || !this.select) return;
        const selectedOption = this.select.options[this.select.selectedIndex];
        const swatchValue = selectedOption?.dataset.optionSwatchValue;
        swatchEl.style.setProperty('--swatch-background', swatchValue || 'transparent');
      }

      // Mirrors snippets/product-volume.liquid's quantity_value/quantity_unit
      // formatting so the sticky bar's volume text stays in sync with
      // whatever that snippet shows elsewhere on the page -- same unit
      // abbreviations, same '.0' stripping, same "no unit price
      // measurement" fallback. The "|" separator's visibility is CSS-only
      // (:has() on the review badge's real review count, matching every
      // other volume|reviews line built this session) since review count
      // doesn't change per variant -- only the volume text itself needs
      // updating here.
      updateVolume() {
        const volumeEl = this.querySelector('[data-sticky-atc-volume]');
        if (!volumeEl) return;

        const upm = this.currentVariant && this.currentVariant.unit_price_measurement;
        if (!upm || !upm.quantity_value) {
          volumeEl.textContent = '';
          return;
        }

        const unitMap = { ML: 'ml', CL: 'cl', L: 'l', MG: 'mg', G: 'g', KG: 'kg' };
        const unit = unitMap[upm.quantity_unit] || String(upm.quantity_unit || '').toLowerCase();
        const qty = String(upm.quantity_value).split('.0').join('');

        // 2026-10-04: count units ("7 pairs"), label from data-count-unit (custom.count_unit).
        if (unit === 'item') {
          const label = volumeEl.dataset.countUnit || 'item';
          volumeEl.textContent = qty === '1' ? `1 ${label}` : `${qty} ${label}s`;
          return;
        }

        volumeEl.textContent = `${qty}${unit}`;
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updateDropdownSwatch();
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}
